import React, {useState} from 'react';
import {NumberInput} from '@mantine/core';
import {useField} from "formik";
import '../../../App.css';
import {CurrencyFormat} from "../../utils/CurrencyFormat";
import {useMediaQuery} from "react-responsive";

function MantineNumberField(props) {
    const {label, name, min, max} = props;
    const [field, meta, helpers] = useField(name);
    const [value, setValue] = useState(field.value);
    const {setValue: setFieldValue, setTouched} = helpers;
    const [showWarning, setShowWarning] = useState({show:false, label: "mínima", value: 0});

    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });

    const handleBlur = (v) => {
        setTouched(name, false)
        if (min !== undefined) {
            if (value < min) {
                setFieldValue(value)
                setValue(min)
                setShowWarning({show:true, label: "mínima", value: min})
            } else if (value > max) {
                setFieldValue(max)
                setValue(max)
                setShowWarning({show:true, label: "máxima", value: max})
            } else {
                setFieldValue(value)
                setValue(value)
            }
        } else {
            setFieldValue(value)
            setValue(value)
        }
    }

    return (
        <>
            <NumberInput
                {...props}
                noClampOnBlur
                hideControls
                label={label}
                value={value}
                onBlur={(v) => handleBlur(v)}
                onChange={(e) => setValue(e)}
                parser={(v) => v.replace(/\$\s?|(\.*)/g, '')}
                formatter={(v) =>
                    !Number.isNaN(parseFloat(v))
                        ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        : '$ '
                }
                error={meta.error && meta.touched && <div>{meta.error}</div>}
            />
            <p className="warningMessage" style={{display: showWarning['show'] ? "block" : "none", fontSize: isMobileDevice ? "10px" : "14px"}}>
                La suma {showWarning['label']} es $ {CurrencyFormat(showWarning['value'])}
            </p>
        </>
    );
}

export default MantineNumberField;